'use client';

import {
  FolderOpen, Package, Warehouse, UserCheck, UserCog, ShieldCheck,
  Landmark, Hash, Percent, Tags, Ruler,
} from 'lucide-react';
import { useSubscriptionStatus } from '@/features/billing/hooks/use-billing';
import { NavLeafItem } from '@/shared/components/layout/nav-leaf-item';
import { SecondaryNavColumn } from '@/shared/components/layout/secondary-nav-column';

export type NomenclItem = {
  id: string;
  label: string;
  icon: any;
  /** Optional Pro module code; if user lacks the addon, item shows ProBadge but rendering not blocked here. */
  module?: string;
};

export const NOMENCL_ITEMS: readonly NomenclItem[] = [
  { id: 'grupuri', label: 'Grupuri clienți', icon: FolderOpen },
  { id: 'produse', label: 'Produse & Servicii', icon: Package },
  { id: 'depozite', label: 'Depozite', icon: Warehouse, module: 'stock' },
  { id: 'delegati', label: 'Delegați', icon: UserCheck },
  { id: 'emitenti', label: 'Emitenți', icon: UserCog },
  { id: 'gestionari', label: 'Gestionari', icon: ShieldCheck, module: 'stock' },
  { id: 'conturi-bancare', label: 'Conturi bancare', icon: Landmark },
  { id: 'serii', label: 'Serii documente', icon: Hash },
  { id: 'cote-tva', label: 'Cote TVA', icon: Percent },
  { id: 'unitati-masura', label: 'Unități măsură', icon: Ruler },
  { id: 'categorii-cheltuieli', label: 'Categorii cheltuieli', icon: Tags },
];

interface NomenclatoareNavProps {
  activeId: string;
  onTabChange: (id: string) => void;
}

export function NomenclatoareNav({ activeId, onTabChange }: NomenclatoareNavProps) {
  const { data: subStatus } = useSubscriptionStatus();
  const activeModules = (subStatus?.subscription?.addons || []) as string[];
  const isLocked = (mod?: string) => !!mod && !activeModules.includes(mod);

  return (
    <SecondaryNavColumn ariaLabel="Nomenclatoare">
      <>
        {NOMENCL_ITEMS.map((tab) => {
          const isActive = activeId === tab.id;
          const locked = isLocked(tab.module);
          const rightSlot = locked ? (
            <span className="text-[0.625rem] font-semibold uppercase tracking-wider rounded px-1.5 py-0.5 bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300">
              Pro
            </span>
          ) : undefined;
          return (
            <NavLeafItem
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              icon={tab.icon}
              label={tab.label}
              active={isActive}
              rightSlot={rightSlot}
              className="lg:mx-1"
              truncate={false}
            />
          );
        })}
      </>
    </SecondaryNavColumn>
  );
}
